import { z } from 'zod';
import { bookingStatus } from './shift.js';

export const attendanceInput = z.object({ kind: z.enum(['check_in', 'check_out']) }).strict();
export type AttendanceInput = z.infer<typeof attendanceInput>;
export const attendanceEvent = z.object({
  id: z.string(),
  kind: z.enum(['check_in', 'check_out']),
  eventAt: z.string(),
  source: z.string(),
  actorUserId: z.string().nullable(),
});
export const attendanceView = z.object({
  bookingId: z.string(),
  bookingStatus,
  locationName: z.string(),
  locationTimezone: z.string(),
  scheduledStart: z.string(),
  scheduledEnd: z.string(),
  events: z.array(attendanceEvent),
  canCheckIn: z.boolean(),
  canCheckOut: z.boolean(),
  reason: z.string(),
  checkInOpensAt: z.string(),
  checkOutClosesAt: z.string(),
  isProfessionalOwner: z.boolean(),
  checkedAt: z.string(),
  suggestedTimes: z.object({ startsAt: z.string(), endsAt: z.string() }).nullable(),
});
export type AttendanceView = z.infer<typeof attendanceView>;
